import { setData } from "rivals/shared/utils/qa";

function Sheets({
  height,
  sheetId,
  gid
}: {
  gid: string;
  height: string;
  sheetId: string;
}): JSX.Element {
  return (
    <iframe
      height={height}
      src={`https://docs.google.com/spreadsheets/d/${sheetId}/pubhtml?gid=${gid}&amp;single=true&amp;widget=true&amp;headers=false`}
      style={{ border: 0 }}
      title={`template-google-sheets-${sheetId}-${gid}`}
      width="100%"
      {...setData("template-google-sheets", `${sheetId}-${gid}`)}
    />
  );
}

export default Sheets;
